<template>
  <div class="page-nav-container">
    <el-menu class="page-nav" :default-active="active" :default-openeds="default_opened" ref="menu">
      <el-menu-item :index="$location.dashboard().name">
        <router-link :to="$location.dashboard(false)">
          <icon name="user"></icon>
          个人主页
        </router-link>
      </el-menu-item>
      <el-menu-item :index="$location.coming_soon().name + JSON.stringify({tag: '教师档案'})"
                    class="coming-soon">
        <router-link :to="$location.coming_soon({tag: '教师档案'}, false)">
          <icon name="file-text-o"></icon>
          教师档案
        </router-link>
      </el-menu-item>
      <el-submenu index="材料上传">
        <template slot="title">
          <a>
            <icon name="cloud-upload"></icon>
            材料上传
          </a>
        </template>
        <el-menu-item :index="$location.achievement_list().name">
          <router-link :to="$location.achievement_list(false)">
            个人成果上传
          </router-link>
        </el-menu-item>
        <el-menu-item :index="$location.collection_list().name">
          <router-link :to="$location.collection_list(false)">
            各类文件上传
          </router-link>
        </el-menu-item>
        <el-menu-item :index="$location.coming_soon().name + JSON.stringify({tag: '其他材料上传'})"
                      class="coming-soon">
          <router-link :to="$location.coming_soon({tag: '其他材料上传'}, false)">
            其他材料上传
          </router-link>
        </el-menu-item>
      </el-submenu>
      <el-menu-item :index="$location.file_center().name">
        <router-link :to="$location.file_center(false)">
          <icon name="share-alt"></icon>
          部门文件共享
        </router-link>
      </el-menu-item>
      <el-submenu index="校内信息查询" class="coming-soon">
        <template slot="title">
          <a>
            <icon name="search"></icon>
            校内信息查询
          </a>
        </template>
        <el-menu-item :index="$location.coming_soon().name + JSON.stringify({tag: '班级查询'})"
                      class="coming-soon">
          <router-link :to="$location.coming_soon({tag: '班级查询'}, false)">
            班级查询
          </router-link>
        </el-menu-item>
        <el-menu-item :index="$location.coming_soon().name + JSON.stringify({tag: '学生查询'})"
                      class="coming-soon">
          <router-link :to="$location.coming_soon({tag: '学生查询'}, false)">
            学生查询
          </router-link>
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="page-content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      default_opened: ['材料上传'],
      active: null,
    }
  },
  methods: {
    init () {
      if (this.$refs.menu.items[this.$route.name]) {
        this.active = this.$route.name
      } else if (this.$refs.menu.items[this.$route.name + JSON.stringify(this.$query)]) {
        this.active = this.$route.name + JSON.stringify(this.$query)
      }
    },
  },
  mounted () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue